import { render, staticRenderFns } from "./saveInsuranceOrder.vue?vue&type=template&id=097b6abc&scoped=true"
import script from "./saveInsuranceOrder.vue?vue&type=script&lang=js"
export * from "./saveInsuranceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b6abc",
  null
  
)

export default component.exports